export default "__VITE_ASSET__a3f7e6ce__"